import { useContext } from "react"
import { forwardRef } from "@chakra-ui/react"
import FormContext from "context/FormContext"
import { AuthContext } from "context/AuthContext"

import {
  Searchbox,
  SearchOption,
  filterOptionsBySearchTerm,
} from "components/Searchbox"
import { formatSchoolName } from "utilities/formatters";
import { CustomSearch } from "api/customSearch"

export interface HighSchoolData {
  OrgName: string
  StateCd: string
  City: string
  CeebCode: string
}

interface SchoolOption extends SearchOption {
  ceebCode: string
}

export const HighSchoolSearch = forwardRef<any, "div">((props, ref) => {
  const { name, ...rest } = props
  const {
    form: { getValues },
  } = useContext(FormContext)
  const { token } = useContext(AuthContext)
  const formValues = getValues()

  const searchHighSchools = async (searchTerm = ""): Promise<SchoolOption[]> => {
    if (!token || token === "") return []

    try {
      const response = await CustomSearch.highSchoolSearch(searchTerm, token)
      if (!response) return []

      const options = response.data.map(
        ({ OrgName, City, StateCd, CeebCode }) => {
          return {
            label: formatSchoolName(OrgName, City, StateCd),
            value: formatSchoolName(OrgName, City, StateCd),
            ceebCode: CeebCode
          }
        }
      )

      return [
        ...filterOptionsBySearchTerm(options, searchTerm),
        {
          label: "I don't see my school",
          value: "I don't see my school",
          ceebCode: "",
        }
      ]
    } catch (error) {
      console.error("Error searching for high schools:", error)
      return []
    }
  }

  return (
    <Searchbox
      ref={ref}
      name={props.name}
      defaultValue={formValues[name]}
      loadOptions={searchHighSchools}
      {...rest}
    />
  )
})
